module.exports = __webpack_public_path__ + "img/IMG_5909.463ddc1b.jpg";